
import {gsap} from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin( ScrollToPlugin );

function getUnitlessHeaderHeight( additionalGutter = 0 ) {
    let root = document.querySelector( "html" ),
        value = getComputedStyle( root ).getPropertyValue( "--app-header-depth" );
    return parseInt( value, 10 ) + parseInt( additionalGutter, 10 );
}

function anchorSmoothScroll( selectorString, targetSelectorAttribute = "href" ) {
    if ( !selectorString ) { return; }
    const targets = [... document.querySelectorAll( selectorString )];
    if ( !targets ) { return; }

    targets.forEach( element => {
        let targetSelector = element.getAttribute( targetSelectorAttribute ),
            target = document.querySelector( targetSelector );
        if ( !target ) { return; }
        element.addEventListener( "click", ( event ) => {
            event.preventDefault();
            gsap.to( window, {
                scrollTo: { y: targetSelector, offsetY: getUnitlessHeaderHeight( 30 ) }
            } );
        } );
    } );
}

export { anchorSmoothScroll };
